import { render, staticRenderFns } from "./LogsListItem.vue?vue&type=template&id=0b213b3c&"
import script from "./LogsListItem.vue?vue&type=script&lang=js&"
export * from "./LogsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports